import { defineMockBlock } from '@fttb/common';
import { FttbBlocks } from "./constants";
import { defineBlock } from "./utils";
export { AboutConnectionBlock } from "./AboutConnectionBlock";
export { AdditionalInfoBlock } from "./AdditionalInfoBlock";
export { AdditionalServicesBlock } from "./AdditionalServicesBlock";
export { AddressVerificationBlock } from "./AddressVerificationBlock";
export { ArticlesBlock } from "./ArticlesBlock";
export { BannerBlock } from "./BannerBlock";
export { CheckAddressBlock } from "./CheckAddressBlock";
export { DevicesBlock } from "./DevicesBlock";
export { FaqBlock } from "./FaqBlock";
export { HeadingBlock } from "./HeadingBlock";
export { ImageCardsBlock } from "./ImageCardsBlock";
export { InfoCardsBlock } from "./InfoCardsBlock";
export { LeavePhoneBlock } from "./LeavePhoneBlock";
export { NewsBlock } from "./NewsBlock";
export { TariffsBlock } from "./TariffsBlock";
var composeMockBlock = function composeMockBlock(blockName) {
  return defineBlock(blockName)(defineMockBlock(blockName, {
    isLarge: true
  }));
};

// Временные заглушки
export var QuizBlock = composeMockBlock(FttbBlocks.QUIZ);